<template>
  <gj-alert
      type="warning"
      :closable="false">
    <div :class="['gj-explain-alert', font14 ? 'gj-explain-alert--font14' : '']">
      <div class="gj-explain-alert--title">{{title}}：</div>
      <ol class="gj-explain-alert--content">
        <li v-for="(rule, index) in rules"
            :key="index"
            class="gj-explain-alert--rule"
            :style="rule.style"
        >{{rule.text || rule}}</li>
      </ol>
    </div>
  </gj-alert>
</template>

<script>
  import {font14MixIn} from "../../minxins";

  export default {
    name: "gj-explain-alert",
    mixins: [font14MixIn],
    props: {
      title: {
        type: String,
        default: '说明'
      },
      rules: {
        required: true
      }
    }
  }
</script>

<style scoped>
  .gj-explain-alert {
    font-size: 12px;
    margin-bottom: 10px;
  }
  .gj-explain-alert--font14 {
    font-size: 14px;
  }
  .gj-explain-alert--title {
    margin-bottom: 10px;
  }
  .gj-explain-alert--title,
  .gj-explain-alert--content {
    color: #003b80;
  }
  .gj-explain-alert--rule {
    margin-bottom: 5px;
  }
  .el-alert--warning {
    background-color: #e5f0ff;
    border: 1px solid #97c7ff;
  }
</style>
